import { EntityRepository, Repository } from "typeorm";
import { OverTimeEntity } from "./over-time.entity";

@EntityRepository(OverTimeEntity)
export class OverTimeRepository extends Repository<OverTimeEntity> {

    constructor() {
        super();
    }

    async getOtDetails(employeeCode: string, date: string): Promise<any[]> {
        const query = this.createQueryBuilder('over_time')
            .select(` employee_code as employeeCode, employee_name as employeeName, date, status `)
            .where(` employee_code = '${employeeCode}' AND date = '${date}' `)
        return await query.getRawMany();
    }

    async getOtHours(month: number): Promise<any[]> {
        const query = this.createQueryBuilder('over_time')
            .select(` employee_code as employeeCode, employee_name as employeeName, month, SUM(ot_hours) as otHours `)
            .where(` ot_type = 'OT' AND  month = '${month}' AND status = 'APPROVED' `)
            .groupBy(` employee_code `);
        return await query.getRawMany();
    }

    async getOtShifts(month: number): Promise<any[]> {
        const query = this.createQueryBuilder('over_time')
            .select(` employee_code as employeeCode, employee_name as employeeName, month, count(ot_hours) as otShifts `)
            .where(` ot_type = 'Shift' AND  month = '${month}' AND status = 'APPROVED' `)
            .groupBy(` employee_code `);
        return await query.getRawMany();
    }
}